import React from "react";
import { AwardIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { volumes } from "../../data/volumes";
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-404" data-mp="2wzp22u3sj1et">
      <div className="mx-auto max-w-4xl" data-id="element-405" data-mp="2t07xe2w6u8ap">
        <SectionHeading kicker="Inside the Alopecia Clinical Blueprint™" title="6 specialized volumes built around a structured hair loss assessment roadmap." intro="Each volume focuses on a distinct part of alopecia education. Together, they support the five-stage assessment framework." data-id="element-406" data-mp="2szew3hg00azy" />

        <div className="mt-12 space-y-8" data-id="element-407" data-mp="29bpcvym4nj2c">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-mist" data-id="element-408" data-mp="299mbyjjfs5iu">
              <div className={`${v.colorClass} p-5 text-white sm:p-7`} data-id="element-409" data-mp="259asha2t8b8y">
                <p className="inline-block rounded-md bg-white/15 px-3 py-1 text-sm font-extrabold uppercase tracking-[0.14em]" data-id="element-410" data-mp="20c29x8dr2576">
                  Volume {v.numeral}
                </p>
                <h3 className="mt-3 font-display text-3xl font-extrabold uppercase leading-[1.02] sm:text-4xl" data-id="element-411" data-mp="37wmbef8ff1ol">
                  {v.title}
                </h3>
                <p className="mt-2 text-lg font-semibold leading-snug text-white/90" data-id="element-412" data-mp="2u34qaq03dgwg">{v.headline}</p>
              </div>

              <div className="p-5 sm:p-7" data-id="element-413" data-mp="3lwdl43rwtvws">
                <div className="space-y-2 text-[17px] leading-relaxed text-ink" data-id="element-414" data-mp="3lwnbhsgva530">
                  {v.intro.map(p => <p key={p} data-id="element-415" data-mp="3qt49dedvbxta">{p}</p>)}
                </div>

                {v.conditions && <div className="mt-6" data-id="element-416" data-mp="3huikl1hszmk2">
                    <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-417" data-mp="3hthap0cix63x">
                      Conditions covered
                    </p>
                    <ol className="mt-3 grid gap-3 sm:grid-cols-2" data-id="element-418" data-mp="26f3odzxf4yq0">
                      {v.conditions.map((c, i) => <li key={c.name} className="flex items-start gap-3 rounded-2xl bg-white p-3.5" data-id="element-419" data-mp="bzer4edh2vz6" data-mpi={i}>
                          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy-900 text-sm font-bold text-white" data-id="element-420" data-mp="713fpz7j4deu">
                            {i + 1}
                          </span>
                          <div data-id="element-421" data-mp="3uccruni39sue">
                            <p className="font-bold leading-snug text-ink" data-id="element-422" data-mp="3ubbicngq1ees">{c.name}</p>
                            {c.description && <p className="mt-1 text-sm leading-snug text-ink-muted" data-id="element-423" data-mp="3keozg47ygxfe">{c.description}</p>}
                          </div>
                        </li>)}
                    </ol>
                  </div>}

                <div className="mt-6" data-id="element-424" data-mp="1do8obre9ud9s">
                  <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand" data-id="element-425" data-mp="1dn7fzuon44vr">
                    {v.listLabel}
                  </p>
                  <ul className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-426" data-mp="2rkjwg3wv946s">
                    {v.items.map(item => <li key={item} className="flex items-start gap-2.5 leading-snug text-ink" data-id="element-427" data-mp="2witqgb6utyqt">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-428" data-mp="31a3c70pa8hxf" />
                        {item}
                      </li>)}
                  </ul>
                </div>

                <div className="mt-6 flex items-start gap-3 rounded-2xl bg-gold-soft p-4" data-id="element-429" data-mp="28nil81cpy7ue">
                  <AwardIcon className="mt-0.5 h-6 w-6 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-430" data-mp="2dl0y22tux77o" />
                  <p className="leading-snug text-ink" data-id="element-431" data-mp="2hl1ajhxeb8c3">
                    <strong className="uppercase" data-id="element-432" data-mp="2mlpcuzr2rblm">Your result:</strong> {v.result}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12 rounded-3xl bg-navy-900 p-6 text-center text-white sm:p-10" data-id="element-433" data-mp="1uoveq8nwo3e">
          <h3 className="font-display text-3xl font-extrabold uppercase leading-tight sm:text-4xl" data-id="element-434" data-mp="dsvu4wbtgc6">
            Get all 6 specialized clinical volumes
          </h3>
          <p className="mx-auto mt-3 max-w-xl text-white/80" data-id="element-435" data-mp="3rmgjwslybhnf">
            Everything you need to study and organize the five-stage initial assessment framework in
            one collection.
          </p>
          <p className="mt-6 text-lg font-semibold text-white/70" data-id="element-436" data-mp="5f8ke6xpq4zb">
            Suggested collection value: <span className="line-through" data-id="element-437" data-mp="jau2rv9fxqir">$89</span>
          </p>
          <p className="font-display text-5xl font-extrabold uppercase text-gold sm:text-6xl" data-id="element-438" data-mp="ed0zb9zivam6">
            Your price: just $27 USD
          </p>
          <CTAButton className="mt-6" tone="dark" label="Get the complete Alopecia Clinical Blueprint™" note="One-time payment · Digital educational collection" data-id="element-439" data-mp="t4jex6ogz350" />
        </div>
      </div>
    </section>;
}